module.exports = __webpack_public_path__ + "static/media/bottom-arrow.96fd3a72.svg";